import {} from "../net/index.js";
import { formatPort } from "../port/formatPort.js";
import {} from "../port/index.js";
export function checkPortSigns(net, first, second) {
    if (first.sign === 1 && second.sign === 1) {
        throw new Error([
            `[checkPortSigns] I expect the two ports to have opposite signs,`,
            `  but they all have positive sign.`,
            ``,
            `  first port: ${formatPort(net, first)}`,
            `  second port: ${formatPort(net, second)}`,
        ].join("\n"));
    }
    if (first.sign === -1 && second.sign === -1) {
        throw new Error([
            `[checkPortSigns] I expect the two ports to have opposite signs,`,
            `  but they all have negative sign.`,
            ``,
            `  first port: ${formatPort(net, first)}`,
            `  second port: ${formatPort(net, second)}`,
        ].join("\n"));
    }
}
//# sourceMappingURL=checkPortSigns.js.map